var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 14C4.68613 14 1.99984 11.3137 1.99984 8C1.99984 4.68629 4.68613 2 7.99984 2C11.3135 2 13.9998 4.68629 13.9998 8C13.9998 11.3137 11.3135 14 7.99984 14ZM0.666504 8C0.666504 12.0501 3.94975 15.3333 7.99984 15.3333C12.0499 15.3333 15.3332 12.0501 15.3332 8C15.3332 3.94991 12.0499 0.666662 7.99984 0.666662C3.94975 0.666662 0.666504 3.94991 0.666504 8Z",
    fill: "#0B907B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13775 10.4714C8.8774 10.7317 8.45529 10.7317 8.19494 10.4714L6.19494 8.47139C5.93459 8.21104 5.93459 7.78893 6.19494 7.52858L8.19494 5.52859C8.45529 5.26824 8.8774 5.26824 9.13775 5.52859C9.3981 5.78893 9.3981 6.21104 9.13775 6.47139L7.60915 7.99999L9.13775 9.52859C9.3981 9.78893 9.3981 10.211 9.13775 10.4714Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBack);
export default __webpack_public_path__ + "static/media/calendar-back.0face29114f75ea6cca46873f02cd41b.svg";
export { ForwardRef as ReactComponent };